import React, { useState } from "react";
import PropTypes from "prop-types";
import { UncontrolledButtonDropdown, DropdownMenu, DropdownToggle, Tooltip } from "reactstrap";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import uuidv4 from "uuid/v4";

const ColumnsFilter = ({ columnFilters, onColumnFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const toggle = () => setIsTooltipOpen(!isTooltipOpen);
  let selectedFilters = columnFilters.filter(x => x.isActive);
  const removeFilter = (key, filters) => {
    return filters.filter(x => x.key !== key);
  };
  const checkboxChange = (newValue, key) => {
    if (newValue) {
      selectedFilters.push(columnFilters.find(x => x.key === key));
      // } else if (selectedFilters.length > 1) {
    } else {
      selectedFilters = removeFilter(key, selectedFilters);
    }
    onColumnFilterChange(selectedFilters);
  };
  const buttonId = "see-columns-button";
  const filterItems = columnFilters.map(x => {
    const uuid = `t${uuidv4().replace(/-/g, "")}`;
    return (
      <ListItem key={uuid} dense button className="item-showColumn">
        <ListItemIcon className="check-showColumn">
          <Checkbox
            edge="start"
            onChange={e => checkboxChange(e.target.checked, x.key)}
            checked={x.isActive}
            className="input-check"
          />
        </ListItemIcon>
        <ListItemText primary={x.label} className="text-showColumn" />
      </ListItem>
    );
  });
  const DropDowntoggle = () => setIsOpen(!isOpen);
  return (
    <UncontrolledButtonDropdown
      toggle={e => {
        if (
          e.srcElement &&
          e.srcElement.className &&
          e.srcElement.className.includes &&
          !e.srcElement.className.includes("Mui")
        ) {
          DropDowntoggle();
        }
      }}
      isOpen={isOpen}
    >
      <DropdownToggle
        tag="button"
        id={buttonId}
        onClick={DropDowntoggle}
        caret
        className="btn-tool-table"
      >
        <span className="icono-show-column" />
        <Tooltip placement="top" isOpen={isTooltipOpen} target={buttonId} toggle={toggle}>
          Ver Columnas
        </Tooltip>
      </DropdownToggle>
      <DropdownMenu className="drop-showColumns">
        <List>{filterItems}</List>
      </DropdownMenu>
    </UncontrolledButtonDropdown>
  );
};

ColumnsFilter.propTypes = {
  columnFilters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired
    })
  ).isRequired,
  onColumnFilterChange: PropTypes.func.isRequired
};

export default ColumnsFilter;
